import { PublicClientApplication, Configuration, PopupRequest, SilentRequest, CacheLookupPolicy } from "@azure/msal-browser";
import { getClientId, getLoginUrl, getTenantId } from '../api/RestUrls';

// Config object to be passed to Msal on creation
const msalConfig: Configuration = {
    auth: {
        clientId: getClientId(),
        redirectUri: getLoginUrl(),
        postLogoutRedirectUri: getLoginUrl(),
        authority: `https://login.microsoftonline.com/${getTenantId()}`
    }
};

const msalInst = new PublicClientApplication(msalConfig);
export const msalInstance = msalInst;

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"],
    extraScopesToConsent: [ `api://${getClientId()}/access_via_approle_assignments`]
};

const silentRequest: SilentRequest = {
    // scopes: ["User.Read"],
    scopes: [`api://${getClientId()}/access_via_approle_assignments`],
    // CacheLookupPolicy.Default does not throw in case of invalid_grant error
    cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken
};


export async function getToken() {
    // Providing an account in the token request is not required if there is an active account set
    // const account = instance.getActiveAccount();
    // const accessTokenRequest = {
    //   scopes: ["user.read"],
    //   account: account || {}
    // }
    
    const accessToken = await msalInst.acquireTokenSilent(silentRequest).then(function(accessTokenResponse) {
      // Acquire token silent success
      // Return token to be used in API call
      let accessToken = accessTokenResponse.accessToken;
      return accessToken;
    }).catch(function (error) {
      //Acquire token silent failure
      if (error.errorMessage.indexOf("interaction_required") !== -1) {
        console.log("interaction_required", error);
      }
      console.log(error);
    });
    return accessToken;
  }


export const appRoles = {
  Admin: "Numerus.Admin",
  SertyReporter: "Numerus.SertyReporter",
  GuestReporter: "Numerus.GuestReporter"
}
